import lazyLoad from '@utils/lazyLoad'

const emailRoutes = [
  {
    path: '/email/channel',
    exact: true,
    component: lazyLoad(() => import('@views/Email/channel'))
  },
  {
    path: '/email/template',
    exact: true,
    component: lazyLoad(() => import('@views/Email/template'))
  },
  {
    path: '/email/send',
    exact: true,
    component: lazyLoad(() => import('@views/Email/send'))
  },
  {
    path: '/email/analysis',
    exact: true,
    component: lazyLoad(() => import('@views/Email/analysis'))
  },
  {
    path: '/email/account',
    exact: true,
    component: lazyLoad(() => import('@views/Email/account'))
  }
]

export default emailRoutes
